// Payload builder for the "check all" box on the billing Reviewed columns
// (ERA claim details, EDI 837Ps, EDI claim statuses).
//
// The two directions are not symmetric, so they are built differently.
//
// Unchecking is destructive and not idempotent: sending "false" for every row
// would clear rows another biller marked since this page rendered, and the
// server's update_all leaves no audit trail. So the off direction sends only
// rows that are currently ticked on screen.
//
// Checking is idempotent - the server COALESCEs the timestamp, so re-marking an
// already-reviewed row is a no-op that preserves the original marking. Diffing
// there would be actively wrong: a row another biller
// un-reviewed after this page rendered still looks ticked in the browser, so it
// would be skipped and left needs-review while the box shows ticked and the
// toast claims the page is done. The on direction therefore sends every
// rendered row and lets the server decide.

/**
 * Build the batch payload for a check-all toggle.
 *
 * @param {Array<{id: string, checked: boolean}>} rows current state of the row checkboxes
 * @param {boolean} isChecked the state the check-all box was just moved to
 * @returns {Object} map of row id to "true"/"false": every rendered row when
 *   checking, and only the currently-ticked rows when unchecking
 */
export function reviewCheckAllPayload(rows, isChecked) {
  const payload = {};

  rows.forEach((row) => {
    if (!row || !row.id) return;
    // Off direction only: skip rows already in the target state.
    if (!isChecked && !row.checked) return;

    payload[row.id] = isChecked ? 'true' : 'false';
  });

  return payload;
}

export default reviewCheckAllPayload;
